// src/pages/AgriLinkHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const AgriLinkHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");
  const [openGroup, setOpenGroup] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/dashboard");
  };

 const groupNames = [
  { label: "Digital Income", emoji: "💰" },
  { label: "Digital Learning", emoji: "💡" },
  { label: "Task & Management", emoji: "🗂️" },
  { label: "Agri Marketplace", emoji: "🛒" },
  { label: "Community & Social", emoji: "🤝" },
  { label: "Recognition & Progress", emoji: "🏅" },
  { label: "Agri Innovations", emoji: "🚜" },
  { label: "Analytics & Insights", emoji: "📊" },
  { label: "Wishes & Fun", emoji: "🎮" },  
  { label: "Hero Products", emoji: "🌰" },    
  { label: "Drone Operations Services", emoji: "🛩️" },    
];

const menuButtons1 = [
  // 💰 DIGITAL INCOME
  { label: "My Monthly Digital Income", emoji: "💻🌱", link: "/bookshelf", group: "Digital Income" },
  { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Income" },
  { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
  { label: "Resell", emoji: "♻️", link: "/agrilink-enroll", group: "Digital Income" },
  { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Income" },
  { label: "Rewarding Videos", emoji: "🎥🌾", link: "/orderflow-spotbuy", group: "Digital Income" },
  { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

  // 💡 DIGITAL LEARNING
  { label: "My Immersive Digital Books", emoji: "📚", link: "/bookshelf", group: "Digital Learning" },
  { label: "AgriLink Digital Books", emoji: "🗓️", link: "/agrilink-bookworld", group: "Digital Learning" },
  { label: "Farmer's AI Counselling", emoji: "🤖", link: "/aicounselling-about", group: "Digital Learning" },
  { label: "Agri Workshop", emoji: "📚", link: "/agrilink-trainingworkshop", group: "Digital Learning" },
  { label: "Agri Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Digital Learning" },
  { label: "kissanTube", emoji: "▶️", link: "/kissantube", group: "Digital Learning" },

  // 🗂️ TASK & MANAGEMENT
  { label: "Farmer's Daily Life", emoji: "🌾", link: "/agrilink-daily", group: "Task & Management" },
  // { label: "Farmer's Health", emoji: "🌾", link: "/agrilink-health", group: "Task & Management" },
  { label: "Farmer's Diary", emoji: "📓", link: "/mydiary-home", group: "Task & Management" },
  { label: "Attendance", emoji: "🕒", link: "/chronocheck-home", group: "Task & Management" },
  { label: "AgriLoan", emoji: "💰", link: "/agrilink-loan", group: "Task & Management" },
  { label: "AgriInsurance", emoji: "🛡️", link: "/agrilink-insurance", group: "Task & Management" },

  // 🛒 AGRI MARKETPLACE
  { label: "Catalogue", emoji: "🔍", link: "/orderflow-products", group: "Agri Marketplace" },
  { label: "Create Basket", emoji: "🧺", link: "/createmyvegbasket", group: "Agri Marketplace" },
  { label: "APMC", emoji: "🏪", link: "/apmc", group: "Agri Marketplace" },
  { label: "Import-Export", emoji: "🚢", link: "/agrilink-exportimport", group: "Agri Marketplace" },
  { label: "Wholesale Commodity Market", emoji: "🏪", link: "/agrilink-commoditywholesale", group: "Agri Marketplace" },
  { label: "Agriproducts Packaging", emoji: "📦", link: "/agrilink-packaging", group: "Agri Marketplace" },
  { label: "Contract Farming", emoji: "🤝", link: "/agrilink-contractfarming", group: "Agri Marketplace" },
  { label: "Unity Deals", emoji: "🛒", link: "/agrilink-unitydeals", group: "Agri Marketplace" },
  { label: "AgriXpress: Quick Delivery", emoji: "⚡", link: "/agrilink-xpresshome", group: "Agri Marketplace" },
  { label: "Wholesale", emoji: "🚜", link: "/agrilink-wholesale", group: "Agri Marketplace" },
  { label: "Nearby Deals", emoji: "📍", link: "/agrilink-nearbydeals", group: "Agri Marketplace" },
  { label: "Agri Real Assets", emoji: "🌾", link: "/agrilink-assets", group: "Agri Marketplace" },
  { label: "Products", emoji: "📦", link: "/orderflow-products", group: "Agri Marketplace" },
  { label: "Services", emoji: "🛠️", link: "/think-service-home", group: "Agri Marketplace" },
  { label: "Rental", emoji: "🏠", link: "/think-rent-home", group: "Agri Marketplace" },
  { label: "Enquiry", emoji: "📩", link: "/agrilink-leads", group: "Agri Marketplace" },
  { label: "Complaints", emoji: "⚠️", link: "/agrilink-complaints", group: "Agri Marketplace" },

  // 🤝 COMMUNITY & SOCIAL
  { label: "Agri Digital Card", emoji: "🪪📲", link: "/contact-genious/farmer", group: "Community & Social" },
  { label: "Farm Jobs", emoji: "👨‍🌾", link: "/agrijobs-home", group: "Community & Social" },
  { label: "Agri & Rural Events", emoji: "🎪", link: "/event-flow-home", group: "Community & Social" },
  { label: "POV / Debate", emoji: "⚖️", link: "/povify-home", group: "Community & Social" },
  { label: "Immersive Presentations", emoji: "🖼️", link: "/visualbrief-home", group: "Community & Social" },
  { label: "Support a Farmer", emoji: "🤝👨‍🌾", link: "/agrilink-supportfarmer", group: "Community & Social" },

  // 🏅 RECOGNITION & PROGRESS
  { label: "SAKSHAM Ranking", emoji: "🏅", link: "/sakshamfarmerscore", group: "Recognition & Progress" },
  { label: "Winners", emoji: "🏆", link: "/agrilinkdb", group: "Recognition & Progress" },

  // 🚜 AGRI INNOVATIONS
  { label: "Agri Innovations", emoji: "💡🚜", link: "/agrilink-innovationhub", group: "Agri Innovations" },
  { label: "Digital Twin", emoji: "🧠", link: "/agrilink-digitaltwin", group: "Agri Innovations" },
  { label: "Agri Tourism", emoji: "🌾", link: "/agrilink-agritourism", group: "Agri Innovations" },
  { label: "Vertical Farming", emoji: "🏙️", link: "/agrilink-verticalfarming", group: "Agri Innovations" },
  { label: "Agriculture Metaverse", emoji: "🌐", link: "/agrilink-metaverse", group: "Agri Innovations" },

  // 📊 ANALYTICS & INSIGHTS
  { label: "Children Study", emoji: "👧📚", link: "/bookshelf", group: "Analytics & Insights" },
  { label: "Payment Dodger DB", emoji: "📊", link: "/offboarded-home", group: "Analytics & Insights" },

  // 🎮 WISHES & FUN
  { label: "Agri Games", emoji: "🎮", link: "/agrilink-games", group: "Wishes & Fun" },
  { label: "Aalu Dalo Sona Nikalo", emoji: "🥔💰", link: "/aaludalosonanikalocomingsoon", group: "Wishes & Fun" },

  // 🌰 Hero Products
  { label: "Makhana", emoji: "🌰", link: "/agrilink-makhana", group: "Hero Products" },
  { label: "Sattu",   emoji: "🌾", link: "/agrilink-sattu",   group: "Hero Products" },
  { label: "Til",     emoji: "⚫", link: "/agrilink-til",     group: "Hero Products" },
  { label: "Moringa", emoji: "🍃", link: "/agrilink-moringa", group: "Hero Products" },
  { label: "Corn",    emoji: "🌽", link: "/agrilink-corn",    group: "Hero Products" },

  
   // 🛩️ Drone Operations Services
  { label: "DroneOps", emoji: "🛩️", link: "/droneops", group: "Drone Operations Services" },
];

const roles = [
    "🌍 Farm Regional Co-ordinator",
    "📍Area Co-ordinator",
    "🔗Cluster Co-ordinator",
    "🌱Farmer",
    "🏆Think5Whys Aggregator (Self Employment)",
    "👨‍🌾Workers",
    "📦Agri Stockist",
    "🏬Agri Retailer",
    "🛒Other Sellers",
    "🚚Logistic",
    "📦Storage Service",
    "🚢Export-Import",
    "🍽️Food Business",
    "🚮Waste Disposer",
    "🤝NGO",
    "🏢Corporate",
    "📚Agri Scholar",
    "🚁Drone Operators",
    "🧑‍🔬Expert",
    "🐄Vet Doctor",
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-green-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-green-800 px-4 py-3 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-2xl font-bold text-green-400">🌱 AgriLink</div>
          <div className="text-[11px] text-yellow-200">
            An empowerment & transformation engine for agriculture and rural future with Digital Income, Learning & Productivity! 
          </div>
          {/* <div className="hidden text-[11px] text-green-200/90">
            Extending Digital India for Continuous Digital Income, Learning & Productivity!
          </div> */}
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-1">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-green-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-4 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-green-700 text-sm text-green-200 hover:bg-green-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-green-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-green-800 px-4 py-3 space-y-4">

          {/* Auth block (keep as-is if needed) */}
          {isLoggedIn ? (
            <div className="text-center text-green-300 text-xs">
              {userName}
            </div>
          ) : (
            <div className="text-center">
              <Link to="/login" className="text-green-300">Login</Link>
            </div>
          )}

          {/* LEVEL 1: GROUPS */}
          <div className="space-y-2">
            {groupNames.map((group) => {
              const isOpen = openGroup === group.label;

              return (
                <div key={group.label} className="border border-green-800 rounded-md">
                  
                  {/* Group header */}
                  <button
                    onClick={() =>
                      setOpenGroup(isOpen ? null : group.label)
                    }
                    className="w-full flex justify-between items-center px-3 py-2 text-green-200 font-medium"
                  >
                    <span>
                      {group.emoji} {group.label}
                    </span>
                    <span className="text-lg">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>

                  {/* LEVEL 2: ITEMS */}
                  {isOpen && (
                    <div className="bg-[#1f0823] border-t border-green-800">
                      {menuButtons1
                        .filter((item) => item.group === group.label)
                        .map((item) => (
                          <Link
                            key={item.label}
                            to={item.link}
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="block px-4 py-2 text-sm text-green-300 hover:bg-green-900/30"
                          >
                            {item.emoji} {item.label}
                          </Link>
                        ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}


      {/* Top quick links */}
      <div className="bg-green-900/40 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/agrilink-insights" className="hover:text-yellow-200">💭About</a>
          <a href="/rim" className="hover:text-yellow-300">🌏RIM</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️Shorts</Link>
          <a href="/agrilink-updates" className="hover:text-yellow-200">📊Updates</a>
          <a href="/agrilink-faq" className="hover:text-yellow-200">🤔FAQ</a>
          <Link to="/agrilink-globaloutlook" className="hover:text-yellow-200">🌐Outlook</Link>
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-3 text-xs text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-t border-green-700">
        <div className="grid grid-cols-3 xl:grid-cols-5 gap-0 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center border border-green-100 justify-center w-full px-2 py-2 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-black text-yellow-200 shadow-md"
                  : "bg-black text-green-100 hover:bg-green-900"
              }`}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-1 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-y-[1px] gap-x-[2px] place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-green-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-[2px] rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-green-700 hover:text-yellow-200 text-green-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-green-800 text-green-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="text-white hover:text-green-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-green-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default AgriLinkHome;
